export var CARE_ORDER_BABY_STATE;
(function (CARE_ORDER_BABY_STATE) {
    CARE_ORDER_BABY_STATE[CARE_ORDER_BABY_STATE["WAITING"] = 0] = "WAITING";
    CARE_ORDER_BABY_STATE[CARE_ORDER_BABY_STATE["TRANSFERRED"] = 1] = "TRANSFERRED";
    CARE_ORDER_BABY_STATE[CARE_ORDER_BABY_STATE["INVALID"] = 2] = "INVALID";
})(CARE_ORDER_BABY_STATE || (CARE_ORDER_BABY_STATE = {}));
export var CARE_ORDER_BABY_TYPE;
(function (CARE_ORDER_BABY_TYPE) {
    CARE_ORDER_BABY_TYPE[CARE_ORDER_BABY_TYPE["ALL_DAY"] = 0] = "ALL_DAY";
    CARE_ORDER_BABY_TYPE[CARE_ORDER_BABY_TYPE["PART_TIME"] = 1] = "PART_TIME";
})(CARE_ORDER_BABY_TYPE || (CARE_ORDER_BABY_TYPE = {}));
